import React, { useState, useEffect } from 'react';

const Interior = () => {
  const [isLoading, setIsLoading] = useState(true);
  
  // Function to handle iframe load completion
  const handleIframeLoad = () => {
    setIsLoading(false);
  };

  // Set a timeout for slow connections
  useEffect(() => {
    // Backup timeout to hide loader if iframe onLoad doesn't trigger
    const timeoutId = setTimeout(() => {
      setIsLoading(false);
    }, 8000); // 8 seconds timeout

    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <div style={{ width: '100vw', height: '100%', overflow: 'hidden', position: 'relative' }}>
      {isLoading && (
        <div className="absolute inset-0 flex flex-col items-center justify-center bg-white z-10">
          <div className="w-12 h-12 border-4 border-gray-200 border-t-yellow-500 rounded-full animate-spin mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      )}
      
      <iframe
        src="https://works25x.shapespark.com/mockup_flat_interior_01/"
        style={{
          width: '100%',
          height: '100%',
          border: 'none',
          opacity: isLoading ? 0 : 1,
          transition: 'opacity 0.5s ease-in-out'
        }}
        title="Vasudharini Nest Interior"
        onLoad={handleIframeLoad}
        allow="fullscreen; vr; xr-spatial-tracking; accelerometer; gyroscope"
      ></iframe>

      <style>
        {`
          @media (max-width: 768px) { /* Small screens (tablets and phones) */
            div {
              height: 93vh;
            }
          }
          @media (min-width: 769px) and (max-width: 1024px) { /* Tablets */
            div {
              height: 96vh;
            }
          }
          @media (min-width: 1025px) { /* Desktops */
            div {
              height: 100vh;
            }
          }
          
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          
          .animate-spin {
            animation: spin 1s linear infinite;
          }
        `}
      </style>
    </div>
  );
};

export default Interior;